module.exports = __webpack_public_path__ + "static/media/REWARDS.d50cf8cd.png";